module.exports = __webpack_public_path__ + "img/001_front.b9d20f79.png";